import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { bellIconClick, NotifyApi, makertemplatedetails, CheckerChartreport } from "../components/ApiProperty";
import jsPDF from 'jspdf';
import greenbg from '../assets/images/Yellow.png';

import loadingGif from '../assets/images/Loading-Animation.gif';
import { Modal } from 'react-bootstrap';

import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
} from "chart.js";
import axios from "axios";

Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

const Cdashboard = () => {
  const navigate = useNavigate();
  const createdTemplateChartRef = useRef(null);
  const createdTemplateChartInstance = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  let labels = [];
  let tooltipTableNames = [];
  const [isLoading, setIsLoading] = useState(true);
  const [chartDataReady, setChartDataReady] = useState(null);
  const chartContainerRef = useRef(null);
  const [showDoughnut, setShowDoughnut] = useState(true);
  // ✅ REFS
  const chartInitializedRef = useRef(false);
  const [isEmptySummary, setIsEmptySummary] = useState(false);
  const [showChart, setShowChart] = useState(true);
  const [dateFilter, setDateFilter] = useState("All");
  const [selectedBarData, setSelectedBarData] = useState(null); // <-- ADD THIS
  const [refreshChart, setRefreshChart] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'
  const doughnutChartDataRef = useRef(null);
  let csrfToken = sessionStorage.getItem("tokenizedSession");
  const dept = localStorage.getItem("dept");

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    const dept = localStorage.getItem("dept");
    const Activty = 'C';
    if (userRole !== "Checker") return;

    const fetchAllCheckerTemplateDetails = async () => {
      setIsLoading(true);

      try {
        const config = {
          headers: { userId: localStorage.getItem("userid"), "x-csrf-token": csrfToken },
          withCredentials: true,
          params: { userRole, dept, dateFilter, Activty },
        };

        const response = await axios.post(CheckerChartreport, {}, config);
        const allData = response?.data?.["data Information"] || {};

        // ✅ For IT: Draw doughnut based on Review Tables from ALL departments
        if (dept === "IT") {
          const labels = [];
          const reviewCounts = [];
          const tooltipData = [];

          Object.entries(allData).forEach(([deptName, deptData]) => {
            const reviewCount = deptData?.[2]?.["Review Table count"] || 0;
            const reviewTables = deptData?.[2]?.["Review Tables"] || [];

            if (reviewCount > 0) {
              labels.push(deptName);
              reviewCounts.push(reviewCount);
              tooltipData.push(
                reviewTables.map(item => ({
                  name: item["Table Name"],
                  date: item["Last Reviewed Date"],
                }))
              );
            }
          });

          const isEmpty = reviewCounts.reduce((sum, val) => sum + val, 0) === 0;
          setIsEmptySummary(isEmpty);
          if (isEmpty) {
            setIsLoading(false);
            return;
          }

          doughnutChartDataRef.current = {
            labels,
            reviewCounts,
            tooltipData,
            allData,
          };
          // 🎯 draw doughnut chart
          drawITDoughnutChart(labels, reviewCounts, tooltipData, allData);
          setIsLoading(false);
          return;
        }

        // 🔁 For Non-IT departments: fallback to existing logic
        if (!allData[dept]) {
          setIsEmptySummary(true);
          setIsLoading(false);
          return;
        }

        const deptData = allData[dept];
        const approvedTables = deptData[0]?.["Approved Tables"] || [];
        const reviewTables = deptData[2]?.["Review Tables"] || [];
        const rejectedTables = deptData[1]?.["Rejected Tables"] || [];

        const approveCount = deptData[0]?.["Approved Table count"] || 0;
        const reviewCount = deptData[2]?.["Review Table count"] || 0;
        const rejectCount = deptData[1]?.["Rejected Table count"] || 0;

        const isEmpty = approveCount === 0 && reviewCount === 0 && rejectCount === 0;
        setIsEmptySummary(isEmpty);

        if (isEmpty) {
          setIsLoading(false);
          return;
        }
        // For Non-IT: bar chart
        setChartDataReady({
          labels: ["Reviewed", "Approved", "Rejected"],
          detailData: [reviewCount, approveCount, rejectCount],
          tooltipTableNames: [
            reviewTables.map(item => ({ name: item["Table Name"], date: item["Last Reviewed Date"] })),
            approvedTables.map(item => ({ name: item["Table Name"], date: item["Last Approved Date"] })),
            rejectedTables.map(item => ({ name: item["Table Name"], date: item["Last Rejected Date"] })),
          ]
        });

        setShowChart(true);
        setShowDoughnut(false);
      } catch (err) {
        console.error("❌ Failed to fetch checker template details:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllCheckerTemplateDetails();
  }, [refreshChart]);


  const drawITDoughnutChart = (labels, reviewCounts, tooltipData, allData) => {
    const canvas = createdTemplateChartRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // Destroy previous chart instance
    if (createdTemplateChartInstance.current) {
      createdTemplateChartInstance.current.destroy();
      createdTemplateChartInstance.current = null;
    }

    const totalSubmitted = reviewCounts.reduce((sum, val) => sum + val, 0);
    const colors = [
      "#ff6384", "#36a2eb", "#cc65fe", "#ffce56",
      "#ff9f40", "#4bc0c0", "#9966ff", "#c9cbcf"
    ];
    const templateData = {
      labels,
      datasets: [{
        data: reviewCounts,
        backgroundColor: colors.slice(0, reviewCounts.length),
        borderColor: "#ffffff",
        borderWidth: 1
      }],
      totalUsers: totalSubmitted
    };
    createdTemplateChartInstance.current = new Chart(ctx, {
      type: "doughnut",
      data: templateData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              color: 'black',
              font: {
                size: 10,
                weight: 'normal',
                family: 'Arial, sans-serif'
              },
              boxWidth: 15,
              padding: 10,
              useBorderRadius: false,
              generateLabels(chart) {
                const dataset = chart.data.datasets[0];
                const labels = chart.data.labels;
                return labels.map((label, i) => ({
                  text: `${label} (${dataset.data[i]})`,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: 'transparent',
                  lineWidth: 0,
                  hidden: !chart.isDatasetVisible(0),
                  index: i
                }));
              }
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              title: (context) => context[0].label,
              label: (context) => `Reviewed Tables: ${context.parsed}`
            }
          }
        },
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            const selectedDept = labels[index];

            const deptData = allData[selectedDept] || [];

            const approvedTables = deptData[0]?.["Approved Tables"] || [];
            const reviewTables = deptData[2]?.["Review Tables"] || [];
            const rejectedTables = deptData[1]?.["Rejected Tables"] || [];

            const approveCount = deptData[0]?.["Approved Table count"] || 0;
            const reviewCount = deptData[2]?.["Review Table count"] || 0;
            const rejectCount = deptData[1]?.["Rejected Table count"] || 0;

            const isEmpty = approveCount === 0 && reviewCount === 0 && rejectCount === 0;
            setIsEmptySummary(isEmpty);

            if (isEmpty) {
              setIsLoading(false);
              return;
            }
            setChartDataReady({
              labels: ["Reviewed", "Approved", "Rejected"],
              detailData: [reviewCount, approveCount, rejectCount],
              tooltipTableNames: [
                reviewTables.map(item => ({ name: item["Table Name"], date: item["Last Reviewed Date"] })),
                approvedTables.map(item => ({ name: item["Table Name"], date: item["Last Approved Date"] })),
                rejectedTables.map(item => ({ name: item["Table Name"], date: item["Last Rejected Date"] }))
              ]
            });
            setShowChart(true);
            setShowDoughnut(false);
          }
        }
      },
      plugins: [
        {
          id: 'centerText',
          beforeDraw(chart) {
            const { ctx, chartArea, data } = chart;
            const total = data.totalUsers || 0;
            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            ctx.font = '20px Arial';
            ctx.fillStyle = 'black';
            ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);

            ctx.font = '30px Arial';
            ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);

            ctx.restore();
          }
        },
        {
          id: 'segment3DEffect',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            const dataset = chart.data.datasets[0];

            ctx.save();

            meta.data.forEach((arc, index) => {
              const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;

              const baseColor = dataset.backgroundColor[index];
              const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
              gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
              gradient.addColorStop(0.5, baseColor);
              gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

              ctx.fillStyle = gradient;

              ctx.beginPath();
              ctx.moveTo(x, y);
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.fill();

              ctx.shadowColor = 'rgba(0,0,0,0.08)';
              ctx.shadowBlur = 3;
              ctx.shadowOffsetX = 1;
              ctx.shadowOffsetY = 1;

              ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
              ctx.lineWidth = 1;
              ctx.beginPath();
              ctx.arc(x, y, outerRadius, startAngle, endAngle);
              ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
              ctx.closePath();
              ctx.stroke();

              ctx.shadowColor = 'transparent';
              ctx.shadowBlur = 0;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 0;
            });

            ctx.restore();
          }
        },
        {
          id: 'segmentCounts',
          afterDatasetDraw(chart) {
            const { ctx } = chart;
            const dataset = chart.data.datasets[0];
            const meta = chart.getDatasetMeta(0);

            ctx.save();
            ctx.fillStyle = 'black';
            ctx.font = 'bold 14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            meta.data.forEach((arc, index) => {
              const { x, y } = arc.tooltipPosition();
              const value = dataset.data[index];
              ctx.fillText(value, x, y);
            });

            ctx.restore();
          }
        }
      ]
    });

    setShowChart(true);
    setShowDoughnut(true);
  };


  useEffect(() => {
    if (!showChart || !chartDataReady) return;

    let attempts = 0;
    const maxAttempts = 10;

    const tryRenderChart = () => {
      const canvas = createdTemplateChartRef.current;
      if (!canvas) {
        attempts++;
        if (attempts < maxAttempts) {
          requestAnimationFrame(tryRenderChart); // Retry in next paint
        } else {
          console.warn("⚠️ Chart canvas not found after retries");
        }
        return;
      }

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        console.warn("⚠️ Canvas context not available");
        return;
      }

      if (createdTemplateChartInstance.current) {
        createdTemplateChartInstance.current.destroy();
      }

      const { labels, detailData, tooltipTableNames } = chartDataReady;


      createdTemplateChartInstance.current = new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels.map((label, i) => `${label} (${detailData[i]})`),
          datasets: [
            {
              data: detailData,
              backgroundColor: function (context) {
                const chart = context.chart;
                const { ctx, chartArea } = chart;

                if (!chartArea) return null;

                // Gradients in the order: #07beb8 → #f25c54 → #133c55
                const gradient1 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient1.addColorStop(0, '#07beb8');
                gradient1.addColorStop(1, '#967aa1');

                const gradient2 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient2.addColorStop(0, '#f25c54');
                gradient2.addColorStop(1, '#967aa1');

                const gradient3 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient3.addColorStop(0, '#133c55');
                gradient3.addColorStop(1, '#967aa1');

                const gradients = [gradient1, gradient2, gradient3];
                return gradients[context.dataIndex];
              },
              borderRadius: 0,
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              enabled: true,
              callbacks: {
                title: (context) => context[0].label.split(" (")[0],  // Add this line
                label: (context) => `Count: ${context.parsed.y}`,    // Modified this line
              }
            },
          },
          onClick: (event, elements) => {
            if (elements.length > 0) {
              const clickedIndex = elements[0].index;
              const label = labels[clickedIndex];
              const tables = tooltipTableNames[clickedIndex] || [];


              // Show all tables without date filtering
              setSelectedBarData({
                title: label,
                count: tables.length,
                data: tables,
              });
              setShowChart(false);
            }
          },
          scales: {
            x: {
              ticks: {
                color: "black",
                font: {
                  size: 10,         // 👈 smaller label text
                  family: "Arial",  // optional: font family
                },
                maxRotation: 0,     // 👈 no rotation
                minRotation: 0      // 👈 no rotation
              },
              grid: { display: false },
              title: {
                display: true,
                text: "Activity",
                color: "black",
                font: { size: 12, weight: "bold" },
              },
            },

            y: {
              beginAtZero: true,
              ticks: { color: "black", stepSize: 1, precision: 0 },
              grid: { color: "rgba(0,0,0,0.05)" },
              title: {
                display: true,
                text: "Count",
                color: "black",
                font: { size: 14, weight: "bold" },
              },
            },
          },
        },
        // plugins: [bar3DEffectPlugin],
      });

      chartInitializedRef.current = true;
    };

    requestAnimationFrame(tryRenderChart);

  }, [chartDataReady, showChart]);


  useEffect(() => {
    setRefreshChart(prev => !prev);
  }, [dateFilter]);




  const handleBackToSummary1 = () => {
    if (createdTemplateChartInstance.current) {
      createdTemplateChartInstance.current.destroy();
      createdTemplateChartInstance.current = null;
    }

    chartInitializedRef.current = false;
    setSelectedBarData(null);
    setShowChart(true);
    setShowDoughnut(false); // make sure doughnut doesn't render
  };

  const handleCloseModal = () => {
    setModalMessage("");
    setMessageType("");
  };

  const formatTableName = (name) => {
    return name
      ?.replace(/^[^_]+_/, "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase()) || "N/A";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "Pending for Review";

    const date = new Date(dateStr);
    if (isNaN(date)) return "Invalid Date";

    const pad = (n) => n.toString().padStart(2, "0");

    const yyyy = date.getFullYear();
    const mm = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mi = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };


  const getDateLabel = (type) => {
    if (type === "Reviewed") return "Last Reviewed Date";
    if (type === "Approved") return "Last Approved Date";
    if (type === "Rejected") return "Last Rejected Date";
    return "Date";
  };

  const isWithinDateRange = (dateStr, range) => {
    if (!dateStr) return false;  // Add null check
    if (range === "all") return true;

    const daysMap = {
      "Today": 0,
      "last3days": 3,
      "last7days": 7,
      "last30days": 30,
    };

    const days = daysMap[range];
    if (days === undefined) return true;

    const targetDate = new Date(dateStr);
    const today = new Date();

    // Reset time components to compare only dates
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = today - targetDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= days;
  };




  useEffect(() => {
    // Define the async function inside useEffect
    const fetchNotifications = async () => {
      try {
        const config = {
          headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
          withCredentials: true,
        };


        const response = await axios.post(NotifyApi, {}, config);

        const fetchedNotifications = response.data || {};

        setNotifications(fetchedNotifications.notifications || []);
        setNotificationCount(fetchedNotifications.countOfNewNotifications || 0);

        if (fetchedNotifications.notifications && fetchedNotifications.notifications.length > 0) {
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    // Call immediately when component mounts
    fetchNotifications();

    // Set up polling every 60 seconds (optional)
    const intervalId = setInterval(fetchNotifications, 60000);

    // Cleanup function to clear interval when component unmounts
    return () => clearInterval(intervalId);
  }, []);

  const handleBackToDoughnut = () => {
    if (createdTemplateChartInstance.current) {
      createdTemplateChartInstance.current.destroy();
      createdTemplateChartInstance.current = null;
    }

    chartInitializedRef.current = false;
    setSelectedBarData(null);

    const stored = doughnutChartDataRef.current;

    if (stored) {
      drawITDoughnutChart(
        stored.labels,
        stored.reviewCounts,   // ✅ was 'submittedCounts' — wrong
        stored.tooltipData,    // ✅ was 'tooltipTableData' — wrong
        stored.allData         // ✅ was 'allDepartmentData' — wrong
      );
    }

    setShowChart(true);
    setShowDoughnut(true);
  };



  const handlereview = () => {
    navigate('/GapsyRData');
  };
  return (
    <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
      <Header />
      <Navigation />
      <div className="top-0 px-4 py-2 text-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item">
                  <a className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                    <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                  </a>
                </li>

              </ol>
            </nav>
          </div>
          <div className="dropdown ms-auto mt-2 mt-md-0">
            {/* <button className="btn btn-outline-dark btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Quick Links
                        </button> */}
            <ul className={`dropdown-menu dropdown-menu-end ${styles.dropdownMenu}`}>
              <li>
                <a className={`dropdown-item small ${styles.dropdownItem}`} href="#">
                  <i className="bi bi-person-plus me-2"></i>Modify Historical Data
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <main className="flex-grow-1 container-fluid">
        <div className={styles.mainContainer}>
          <div className="container-fluid py-2">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">
                    <div className="mb-2">
                      <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Checker Work Area</h6>
                      <div id="group1" className="row">
                        <div className="col-4 mb-1">
                          <div
                            className={`${styles.customBox} ${styles.csBoxMain} ${styles.activeBox}`}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                          >
                            <a onClick={handlereview} className="text-decoration-none text-reset d-block">
                              <i class="bi bi-arrow-left-right"></i><br />
                              3.1 Approve/Reject
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div
                      style={{
                        backgroundImage: `url(${greenbg})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        borderRadius: '20px',
                        paddingTop: '6px',
                        paddingBottom: '6px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        width: '100%',
                        height: '170px',
                        marginTop: '20px',
                      }}
                    >
                      <h6 className={`pb-1 mb-4 ${styles.borderBottom}`}>Gapsphere Workflow</h6>
                      <div className={`row ${styles.group3}`}>


                        <div className="col-4 mb-1">
                          <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                            <div className="template-text">1. Template Creation</div>
                            <div className="template-icon">
                              <i className="bi bi-file-earmark-plus"></i>
                            </div>
                          </div>
                        </div>

                        <div className="col-4 mb-1">

                          <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                            <div className="template-text">2. Data Submission</div>
                            <div className="template-icon2">
                              <i className="bi bi-journals"></i>
                            </div>

                            {/* </div> */}
                          </div>
                        </div>

                        <div className="col-4 mb-1">
                          <div className={`${styles.customtemplatebox} ${styles.highlightGlow} ${styles.activeBox} ${styles.box}`}>
                            <div className="template-text">3. Data Review</div>
                            <div className="template-icon3">
                              <i className="bi bi-check-circle"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">

                    {/* Header */}
                    <div className="d-flex align-items-center justify-content-between mb-3" style={{ borderBottom: "1px solid black" }}>
                      <h6 className="mb-0">Data Review Summary</h6>
                      {!showChart && !isEmptySummary && (
                        <button className="btn btn-white btn-sm p-1" onClick={handleBackToSummary1}>
                          <i className="bi bi-arrow-left-circle text-dark small"></i>
                        </button>
                      )}
                      {dept === "IT" && !showDoughnut && !selectedBarData && (
                        <button
                          className="btn btn-white btn-sm d-flex align-items-center"
                          onClick={handleBackToDoughnut}
                          title="Back to dhougnut"
                          style={{ padding: "2px 4px" }}
                        >
                          <i className="bi bi-arrow-left-circle" style={{ fontSize: "10px", color: "black" }}></i>
                        </button>
                      )}
                    </div>

                    {/* Body */}
                    {isLoading ? (
                      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                        <span className="mt-2 text-muted">Loading chart</span>
                        <img src={loadingGif} alt="Loading..." style={{ width: '60px', height: '60px' }} />
                      </div>
                    ) : isEmptySummary ? (
                      <div>
                        <p className="text-center py-5">No activity(s) performed by the User</p>
                      </div>

                    ) : selectedBarData ? (
                      <div className={`tableWrapper ${tableStyles.notificationWrapper}`}>
                        <h5 style={{ fontSize: "0.9rem" }}>
                          <strong>{selectedBarData.title.replace(/\s*\(\d+\)/, "")}</strong>
                          <span style={{ marginLeft: "5px", fontWeight: "bold" }}>- {selectedBarData.count}</span>
                        </h5>
                        <hr style={{ margin: "4px 0", borderColor: "black" }} />
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <tbody>
                            {selectedBarData.data.map((item, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td style={{ fontSize: "0.75rem", fontWeight: "bold" }}>{formatTableName(item.name)}</td>
                                </tr>
                                <tr>
                                  <td style={{ fontSize: "0.7rem" }}>
                                    {getDateLabel(selectedBarData.title)} : {formatDate(item.date)}
                                  </td>
                                </tr>
                                <tr><td><hr style={{ margin: "4px 0", borderColor: "black" }} /></td></tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )


                      : showDoughnut ? (
                        <div style={{ position: "relative", height: "280px" }}>
                          <canvas ref={createdTemplateChartRef} height="300" />
                        </div>
                      ) : showChart ? (
                        <div ref={chartContainerRef} style={{ position: "relative", height: "280px" }}>
                          <canvas ref={createdTemplateChartRef} height="300" />
                        </div>
                      ) : null}
                  </div>
                </div>
              </div>


              <div class="col-lg-3 col-md-12">
                <div class={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">
                    <h6 className={`pb-1 ${styles.borderBottom}`}>Pending Activities</h6>
                    <div className={`tableWrapper ${tableStyles.notificationWrapper}`}>
                      {(() => {
                        // First filter out the notifications we don't want to show
                        const filteredNotifications = notifications.filter(
                          (notification) =>
                            notification.CompletedActivity !== null &&
                            ![
                              "Created a Template",
                              "Updated a Template",
                              "Rejected a Data",
                              "Bulk Rejected Data"
                            ].includes(notification.CompletedActivity)
                        );

                        // Then apply distinct operation (updated version)
                        const distinctNotifications = Array.from(
                          filteredNotifications.reduce((map, notification) => {
                            // Create a unique key combining relevant fields
                            const key = `${notification.userId}-${notification.CompletedActivity}-${notification.Tablename}`;
                            if (!map.has(key)) {
                              map.set(key, notification);
                            }
                            return map;
                          }, new Map())
                        ).map(([_, notification]) => notification);

                        // Then check if we have any notifications left after filtering
                        return distinctNotifications.length > 0 ? (
                          <ul className="list-unstyled">
                            {distinctNotifications.map((notification, index) => {
                              // Determine icon and color based on activity type (existing logic)
                              let iconClass = "";
                              let iconColor = "";

                              if (["Rejected a Data", "Rejected a Template", "Rejected a Retrieved Data",
                                "Rejected a Restored Template", "Rejected a Restored Data", "Bulk Rejected Data"]
                                .includes(notification.CompletedActivity)) {
                                iconClass = "bi-file-earmark-plus-fill";
                                iconColor = "text-success";
                              } else {
                                iconClass = "bi-clipboard-check";
                                iconColor = "text-success";
                              }

                              const dept = notification.Tablename.split('_')[0];
                              const displayTableName = notification.Tablename.includes('_')
                                ? notification.Tablename.split('_').slice(1).join('_')
                                : notification.Tablename;

                              // Convert to Proper Case (e.g., "balance_sheet" → "Balance Sheet")
                              const toProperCase = (str) => {
                                return str.replace(/_/g, ' ')
                                  .replace(/\w\S*/g, (word) =>
                                    word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
                                  );
                              };
                              const properTableName = toProperCase(displayTableName);

                              return (
                                <li
                                  // key={`${notification.userId}-${notification.Tablename}`}
                                  key={`${notification.userId}-${notification.Tablename}-${notification.CompletedActivity}`}
                                  onClick={() => {
                                    localStorage.setItem('selectedDept', dept);
                                    localStorage.setItem('selectedTable', notification.Tablename);
                                    localStorage.setItem('completedActivity', notification.CompletedActivity);
                                    navigate("/GapsyRData");
                                    // onclick={handlereview};
                                  }}
                                  className={`d-flex align-items-center mb-1 pb-1 py-2 px-2 ${styles.notificationItem}`}
                                >
                                  <i className={`bi ${iconClass} ${iconColor} fs-5 me-3`}></i>
                                  <span>
                                    <strong>{notification.userId}</strong> has{' '}
                                    <strong><span className="text-dark">{notification.CompletedActivity}</span></strong>{' '}
                                    (<strong>{properTableName}</strong>).
                                    {["Rejected a Data", "Rejected a Template", "Rejected a Retrieved Data",
                                      "Rejected a Restored Template", "Rejected a Restored Data", "Bulk Rejected Data"]
                                      .includes(notification.CompletedActivity) && (
                                        <> Pending for your Modification.</>
                                      )}
                                    {["Submitted a Data", "Modified a Data", "Submitted a Template",
                                      "Modified a Template", "Uploaded a Data", "Retrieved a Data",
                                      "Restored a Template", "Restored a Data", "Modified a Retrieved Data",
                                      "Modified a Existing Template", "Modified a Rejected Template", "Modified a Past Data"]
                                      .includes(notification.CompletedActivity) && (
                                        <> Pending for your Review.</>
                                      )}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p className="text-center py-5">No activity(s) Pending with User</p>
                        );
                      })()}
                    </div>
                  </div>

                  <Modal
                    show={!!modalMessage}
                    onHide={handleCloseModal}
                    backdrop="static"
                    keyboard={false}
                    style={{ marginTop: '12vh' }}
                  >
                    <div
                      className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                      role="alert"
                      style={{ marginBottom: '0' }}
                    >
                      <div className="d-flex align-items-center">
                        {messageType === 'success' ? (
                          <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                        ) : messageType === 'warning' ? (
                          <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                        ) : (
                          <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                        )}
                        <p
                          style={{
                            display: 'inline',
                            marginBottom: '0px',
                            color: messageType === 'success'
                              ? 'green'
                              : messageType === 'warning'
                                ? '#ffc107'
                                : 'red'
                          }}
                        >
                          {modalMessage}
                        </p>
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleCloseModal}
                        style={{
                          width: '15px',
                          height: '15px',
                          fontSize: '8px',
                          position: 'absolute',
                          bottom: '10px',
                          right: '10px'
                        }}
                      />
                    </div>
                  </Modal>

                  <style>{`
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: #000000 #e0e0e0;
        }

        .custom-scrollbar::-webkit-scrollbar {
          width: 2px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background: #e0e0e0;
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: black;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
        }
      `}</style>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cdashboard;
